window.Slick = require('slick-carousel/slick/slick.js')
import 'slick-carousel/slick/slick.css'
